// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getTransferRejectedReason} from '../../shared/repositories';

export const updateRejectedReason = transfer =>
    dispatch => dispatch({
        data: transfer,
        type: actions.UPDATE_TRANSFER_REJECTED_REASON
    });

export const getRejectedReason = userLocale =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getTransferRejectedReason(userLocale);

            dispatch({
                payload,
                type: actions.SET_TRANSFER_REJECTED_REASON
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/transfers/action-creators/rejected-reason.js